export const municipalityCollectionGuard = 'GET /municipalities';
export const placeCollectionGuard = 'GET /municipalities/d+/places';
